<template>
  <default-layout :breadcrumbs="breadcrumbs">
    <main class="recommended-learn">
      <!-- HERO -->
      <section class="recommended-learn-hero">
        <!--        <div class="recommended-learn-hero__overlay"></div>-->

        <div class="recommended-learn-container recommended-learn-hero__container">
          <div class="recommended-learn-hero__copy">
            <div class="hero-kicker">
              <span class="hero-kicker__icon">
                <v-icon>mdi-star-four-points-outline</v-icon>
              </span>

              <span>Listing Rekomendasi</span>
            </div>

            <h1>
              Buat listing Anda
              <span>lebih mudah ditemukan</span>
            </h1>

            <p class="hero-description">
              Pelajari cara mengaktifkan Listing Rekomendasi, memilih periode tayang, dan
              meningkatkan peluang properti Anda dilihat calon pembeli.
            </p>

            <div class="hero-actions">
              <router-link class="hero-button hero-button--primary" to="/">
                <span>Tambah Listing Rekomendasi</span>
                <v-icon>mdi-arrow-right</v-icon>
              </router-link>

              <router-link class="hero-button hero-button--secondary" to="/recommended-listing">
                <v-icon>mdi-format-list-bulleted</v-icon>
                <span>Lihat Listing Aktif</span>
              </router-link>
            </div>

            <div class="hero-highlights">
              <div class="hero-highlight">
                <v-icon>mdi-check-circle</v-icon>
                <span>Posisi lebih menonjol</span>
              </div>

              <div class="hero-highlight">
                <v-icon>mdi-check-circle</v-icon>
                <span>Periode fleksibel</span>
              </div>

              <div class="hero-highlight">
                <v-icon>mdi-check-circle</v-icon>
                <span>Mudah dikelola</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- BENEFIT -->
      <section class="learn-section">
        <div class="recommended-learn-container">
          <div class="section-heading section-heading--center">
            <span class="section-eyebrow">Keuntungan untuk listing Anda</span>

            <h2>Lebih dari sekadar tampil di pencarian</h2>

            <p>
              Listing Rekomendasi membantu properti mendapatkan eksposur yang lebih optimal melalui
              penempatan prioritas dan periode promosi yang dapat disesuaikan.
            </p>
          </div>

          <div class="benefit-grid">
            <article v-for="benefit in benefits" :key="benefit.title" class="benefit-card">
              <div class="benefit-card__top">
                <div class="benefit-card__icon">
                  <v-icon>{{ benefit.icon }}</v-icon>
                </div>

                <span class="benefit-card__decoration"></span>
              </div>

              <h3>{{ benefit.title }}</h3>
              <p>{{ benefit.description }}</p>
            </article>
          </div>
        </div>
      </section>

      <!-- PROCESS -->
      <section class="process-section">
        <div class="recommended-learn-container">
          <div class="section-heading process-section__heading">
            <div>
              <span class="section-eyebrow">Cara kerja</span>
              <h2>Aktif hanya dalam empat tahap</h2>
            </div>

            <p>
              Mulai dari memilih properti hingga listing tampil sebagai rekomendasi, seluruh proses
              dapat dilakukan langsung melalui akun agen Anda.
            </p>
          </div>

          <div class="process-list">
            <article v-for="(step, index) in steps" :key="step.title" class="process-card">
              <div class="process-card__header">
                <span class="process-card__number">
                  {{ String(index + 1).padStart(2, '0') }}
                </span>

                <div class="process-card__icon">
                  <v-icon>{{ step.icon }}</v-icon>
                </div>
              </div>

              <div class="process-card__content">
                <h3>{{ step.title }}</h3>
                <p>{{ step.description }}</p>
              </div>

              <div v-if="index < steps.length - 1" class="process-card__arrow">
                <v-icon>mdi-arrow-right</v-icon>
              </div>
            </article>
          </div>

          <div class="process-note">
            <div class="process-note__icon">
              <v-icon>mdi-lightbulb-outline</v-icon>
            </div>

            <div>
              <strong>Pastikan informasi listing sudah lengkap</strong>
              <p>
                Foto yang jelas, harga yang sesuai, dan deskripsi lengkap membantu listing
                memberikan kesan yang lebih profesional kepada calon pembeli.
              </p>
            </div>
          </div>
        </div>
      </section>

      <!-- FAQ -->
      <section class="faq-section">
        <div class="recommended-learn-container">
          <div class="faq-layout">
            <div class="faq-introduction">
              <span class="section-eyebrow">Pertanyaan umum</span>

              <h2>Hal yang perlu Anda ketahui</h2>

              <p>
                Temukan jawaban seputar proses aktivasi, periode tayang, dan pengelolaan Listing
                Rekomendasi.
              </p>

              <router-link class="faq-introduction__link" to="/recommended-listing">
                <span>Lihat Listing Rekomendasi</span>
                <v-icon>mdi-arrow-right</v-icon>
              </router-link>
            </div>

            <div class="faq-list">
              <details v-for="(item, index) in faqs" :key="item.question" class="faq-item">
                <summary>
                  <div class="faq-item__question">
                    <span class="faq-item__number">
                      {{ String(index + 1).padStart(2, '0') }}
                    </span>

                    <span>{{ item.question }}</span>
                  </div>

                  <span class="faq-item__toggle">
                    <v-icon>mdi-chevron-down</v-icon>
                  </span>
                </summary>

                <div class="faq-item__answer">
                  <p>{{ item.answer }}</p>
                </div>
              </details>
            </div>
          </div>
        </div>
      </section>

      <!-- CTA -->
      <section class="bottom-cta-section">
        <div class="recommended-learn-container">
          <div class="bottom-cta">
            <div class="bottom-cta__copy">
              <span class="bottom-cta__eyebrow"> Tingkatkan visibilitas listing </span>

              <h2>Siap membuat properti Anda lebih menonjol?</h2>

              <p>Pilih listing terbaik Anda dan tentukan periode promosi sesuai kebutuhan.</p>
            </div>

            <router-link class="bottom-cta__button" to="/">
              <span>Tambah Listing Rekomendasi</span>
              <v-icon>mdi-arrow-right</v-icon>
            </router-link>
          </div>
        </div>
      </section>
    </main>
  </default-layout>
</template>

<script>
import DefaultLayout from '@/layouts/default';
import DefaultHeadMixin from '@/mixins/defaultHead';

export default {
  name: 'RecommendedListingCaraKerja',

  components: {
    DefaultLayout,
  },

  mixins: [DefaultHeadMixin],

  async fetch({ store }) {
    const url = 'https://agen.belirumah.co/layanan-agen/rekomendasi-listing/cara-kerja';

    const title = 'Cara Kerja Listing Rekomendasi | Agen BeliRumah.co';

    const description =
      'Pelajari cara kerja, benefit, dan FAQ Listing Rekomendasi untuk meningkatkan visibilitas properti Anda.';

    store.commit('head/SET_CONTENT', {
      title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: description,
        },
        {
          hid: 'og-url',
          property: 'og:url',
          content: url,
        },
        {
          hid: 'og-type',
          property: 'og:type',
          content: 'website',
        },
        {
          hid: 'og-description',
          property: 'og:description',
          content: description,
        },
      ],
      link: [
        {
          rel: 'canonical',
          href: url,
          id: 'canonical',
        },
      ],
    });
  },

  computed: {
    breadcrumbs() {
      if (this.$route.query.mobile === 'true') return [];

      return [
        {
          text: this.$t('breadcrumb.homepage'),
          to: '/',
        },
        {
          text: this.$t('home.sidebarMenu.recommendedListing'),
          to: '/recommended-listing',
        },
        {
          text: 'Cara Kerja',
          to: this.$router.currentRoute.path,
        },
      ];
    },

    benefits() {
      return [
        {
          icon: 'mdi-star-outline',
          title: 'Tampil Lebih Menonjol',
          description:
            'Listing ditempatkan pada area prioritas sehingga lebih mudah menarik perhatian calon pembeli.',
        },
        {
          icon: 'mdi-eye-outline',
          title: 'Potensi Dilihat Lebih Besar',
          description:
            'Eksposur tambahan membantu properti menjangkau lebih banyak pengguna yang relevan.',
        },
        {
          icon: 'mdi-calendar-clock-outline',
          title: 'Periode Tayang Fleksibel',
          description:
            'Pilih periode tanggal yang paling sesuai dengan rencana dan kebutuhan promosi Anda.',
        },
        {
          icon: 'mdi-home-edit-outline',
          title: 'Mudah Dikelola',
          description:
            'Aktivasi dan pengelolaan dilakukan langsung dari listing yang sudah Anda miliki.',
        },
      ];
    },

    steps() {
      return [
        {
          icon: 'mdi-home-search-outline',
          title: 'Pilih Listing',
          description: 'Buka halaman Listing Saya dan tentukan properti yang ingin diprioritaskan.',
        },
        {
          icon: 'mdi-star-circle-outline',
          title: 'Aktifkan Rekomendasi',
          description: 'Pilih fitur Listing Rekomendasi pada properti yang sudah ditentukan.',
        },
        {
          icon: 'mdi-calendar-range-outline',
          title: 'Pilih Periode',
          description: 'Tentukan tanggal tayang berdasarkan periode dan slot yang tersedia.',
        },
        {
          icon: 'mdi-rocket-launch-outline',
          title: 'Listing Siap Tayang',
          description: 'Listing akan tampil sebagai rekomendasi selama periode aktif berlangsung.',
        },
      ];
    },

    faqs() {
      return [
        {
          question: 'Dari mana saya mengaktifkan Listing Rekomendasi?',
          answer:
            'Aktivasi dilakukan melalui halaman Listing Saya. Pilih listing yang memenuhi syarat, kemudian pilih opsi untuk menjadikannya sebagai Listing Rekomendasi.',
        },
        {
          question: 'Apakah saya bisa memilih periode tayang?',
          answer:
            'Ya. Anda dapat memilih periode tanggal yang tersedia sebelum Listing Rekomendasi diaktifkan.',
        },
        {
          question: 'Apa yang terjadi setelah periode berakhir?',
          answer:
            'Setelah periode rekomendasi berakhir, properti tetap aktif dan kembali tampil sebagai listing reguler.',
        },
        {
          question: 'Apakah saya bisa mengganti listing?',
          answer:
            'Pengelolaan listing dapat dilakukan melalui halaman Listing Rekomendasi. Opsi penggantian akan tersedia apabila listing dan periode yang dipilih memenuhi ketentuan.',
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/utils/variables';

.recommended-learn {
  --rl-red: #c81919;
  --rl-red-hover: #ab1313;
  --rl-red-dark: #6f1010;
  --rl-red-soft: #ffffff;
  --rl-red-soft-strong: #f4f4f5;
  --rl-ink: #18191d;
  --rl-heading: #202124;
  --rl-muted: #686d76;
  --rl-muted-dark: #4c5058;
  --rl-line: #e9e9eb;
  --rl-line-soft: #f0f0f1;
  --rl-surface: #ffffff;
  --rl-surface-soft: #f8f8f8;
  --rl-shadow-sm: 0 8px 24px rgba(28, 28, 28, 0.05);
  --rl-shadow-md: 0 18px 45px rgba(28, 28, 28, 0.08);
  --rl-shadow-red: 0 15px 30px rgba(111, 16, 16, 0.18);

  overflow: hidden;
  background: var(--rl-surface);
  color: var(--rl-ink);
  font-family: Poppins-Regular, Poppins, sans-serif;
}

.recommended-learn-container {
  position: relative;
  z-index: 2;
  width: min(1180px, calc(100% - 40px));
  margin: 0 auto;
}

/* ========================================
   GLOBAL TYPOGRAPHY
======================================== */

.recommended-learn h1,
.recommended-learn h2,
.recommended-learn h3,
.recommended-learn p {
  overflow-wrap: break-word;
}

.recommended-learn h1,
.recommended-learn h2,
.recommended-learn h3 {
  color: var(--rl-heading);
  font-family: Poppins-Bold, Poppins, sans-serif;
}

.recommended-learn h1 {
  letter-spacing: -1.6px;
}

.recommended-learn h2 {
  letter-spacing: -0.8px;
}

.recommended-learn h3 {
  letter-spacing: -0.25px;
}

/* ========================================
   HERO
======================================== */

.recommended-learn-hero {
  position: relative;
  min-height: 500px;
  display: flex;
  align-items: center;
  overflow: hidden;
  isolation: isolate;
  background-image: image-set(
    url('https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/static/v2/recommended-listing/cara-kerja-rekomendasi-listing.webp')
      type('image/webp'),
    url('https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/static/v2/recommended-listing/cara-kerja-rekomendasi-listing.png')
      type('image/png')
  );
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.recommended-learn-hero__overlay {
  position: absolute;
  z-index: 1;
  inset: 0;
  pointer-events: none;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.99) 0%,
    rgba(255, 255, 255, 0.96) 35%,
    rgba(255, 255, 255, 0.78) 54%,
    rgba(255, 255, 255, 0.18) 72%,
    rgba(255, 255, 255, 0) 100%
  );
}

.recommended-learn-hero__container {
  width: min(1180px, calc(100% - 40px));
  display: flex;
  align-items: center;
  padding: 64px 0;
}

.recommended-learn-hero__copy {
  width: min(600px, 55%);
}

.hero-kicker {
  width: fit-content;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 6px 13px 6px 7px;
  border: 1px solid var(--rl-line);
  border-radius: 999px;
  color: var(--rl-red-dark);
  background: rgba(255, 255, 255, 0.86);
  box-shadow: 0 5px 18px rgba(82, 16, 16, 0.05);
  font-family: Poppins-SemiBold, Poppins, sans-serif;
  font-size: 13px;
  line-height: 1.4;
  backdrop-filter: blur(8px);
}

.hero-kicker__icon {
  width: 29px;
  height: 29px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #ffffff;
  background: var(--rl-red);
}

.hero-kicker__icon .v-icon {
  color: inherit;
  font-size: 16px;
}

.recommended-learn-hero h1 {
  max-width: 590px;
  margin: 20px 0 18px;
  color: var(--rl-heading);
  font-size: clamp(40px, 4.2vw, 58px);
  font-weight: 700;
  line-height: 1.1;
  text-wrap: balance;
}

.recommended-learn-hero h1 span {
  display: block;
  color: var(--rl-red);
}

.hero-description {
  max-width: 570px;
  margin: 0;
  color: var(--rl-muted-dark);
  font-size: 16px;
  line-height: 1.75;
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-top: 28px;
}

.hero-button {
  min-height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  padding: 0 19px;
  border: 1px solid transparent;
  border-radius: 10px;
  font-family: Poppins-SemiBold, Poppins, sans-serif;
  font-size: 13px;
  line-height: 1;
  text-decoration: none;
  transition: transform 0.2s ease, border-color 0.2s ease, background-color 0.2s ease,
    box-shadow 0.2s ease, color 0.2s ease;
}

.hero-button .v-icon {
  color: inherit;
  font-size: 19px;
}

.hero-button:hover {
  text-decoration: none;
  transform: translateY(-2px);
}

.hero-button--primary {
  color: #ffffff;
  background: var(--rl-red);
  box-shadow: var(--rl-shadow-red);
}

.hero-button--primary:hover {
  color: #ffffff;
  background: var(--rl-red-hover);
  box-shadow: 0 18px 34px rgba(111, 16, 16, 0.22);
}

.hero-button--secondary {
  border-color: #dedfe2;
  color: var(--rl-heading);
  background: rgba(255, 255, 255, 0.84);
  box-shadow: 0 8px 22px rgba(24, 24, 24, 0.06);
  backdrop-filter: blur(8px);
}

.hero-button--secondary:hover {
  border-color: #c9cace;
  color: var(--rl-red);
  background: #ffffff;
}

.hero-highlights {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 20px;
  margin-top: 25px;
}

.hero-highlight {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: var(--rl-muted-dark);
  font-family: Poppins-Medium, Poppins, sans-serif;
  font-size: 12px;
  line-height: 1.5;
}

.hero-highlight .v-icon {
  color: var(--rl-red);
  font-size: 17px;
}

/* ========================================
   SECTION HEADING
======================================== */

.learn-section,
.process-section,
.faq-section,
.bottom-cta-section {
  position: relative;
}

.learn-section {
  padding: 84px 0;
  background: var(--rl-surface);
}

.section-heading {
  margin-bottom: 34px;
}

.section-heading--center {
  max-width: 720px;
  margin-right: auto;
  margin-bottom: 38px;
  margin-left: auto;
  text-align: center;
}

.section-eyebrow {
  display: block;
  margin-bottom: 10px;
  color: var(--rl-red);
  font-family: Poppins-SemiBold, Poppins, sans-serif;
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.section-heading h2,
.faq-introduction h2,
.bottom-cta h2 {
  margin: 0;
  color: var(--rl-heading);
  font-size: clamp(27px, 3vw, 36px);
  line-height: 1.25;
}

.section-heading > p {
  max-width: 660px;
  margin: 14px auto 0;
  color: var(--rl-muted);
  font-size: 15px;
  line-height: 1.75;
}

/* ========================================
   BENEFIT
======================================== */

.benefit-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.benefit-card {
  position: relative;
  min-width: 0;
  min-height: 250px;
  overflow: hidden;
  padding: 22px;
  border: 1px solid var(--rl-line);
  border-radius: 16px;
  background: var(--rl-surface);
  box-shadow: var(--rl-shadow-sm);
  transition: transform 0.24s ease, border-color 0.24s ease, box-shadow 0.24s ease;
}

.benefit-card:hover {
  border-color: var(--rl-red);
  box-shadow: var(--rl-shadow-md);
  transform: translateY(-5px);
}

.benefit-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.benefit-card__icon {
  width: 48px;
  height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--rl-line);
  border-radius: 14px;
  color: var(--rl-red);
  background: var(--rl-red-soft);
}

.benefit-card__icon .v-icon {
  color: inherit;
  font-size: 24px;
}

.benefit-card__decoration {
  width: 28px;
  height: 4px;
  margin-top: 5px;
  border-radius: 999px;
  background: var(--rl-red);
  opacity: 0.85;
}

.benefit-card h3 {
  margin: 23px 0 9px;
  font-size: 17px;
  line-height: 1.45;
}

.benefit-card p {
  margin: 0;
  color: var(--rl-muted);
  font-size: 13px;
  line-height: 1.75;
}

/* ========================================
   PROCESS
======================================== */

.process-section {
  padding: 84px 0;
  border-top: 1px solid var(--rl-line-soft);
  border-bottom: 1px solid var(--rl-line-soft);
  background: var(--rl-surface-soft);
}

.process-section__heading {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 470px);
  align-items: end;
  gap: 48px;
  margin-bottom: 40px;
}

.process-section__heading > p {
  margin: 0;
  color: var(--rl-muted);
  font-size: 14px;
  line-height: 1.75;
}

.process-list {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.process-card {
  position: relative;
  min-width: 0;
  min-height: 240px;
  padding: 20px;
  border: 1px solid var(--rl-line);
  border-radius: 16px;
  background: var(--rl-surface);
  box-shadow: 0 8px 24px rgba(25, 25, 25, 0.04);
}

.process-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.process-card__number {
  color: #d3d3d6;
  font-family: Poppins-Bold, Poppins, sans-serif;
  font-size: 25px;
  line-height: 1;
  letter-spacing: -1px;
}

.process-card__icon {
  width: 44px;
  height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 13px;
  color: #ffffff;
  background: var(--rl-red);
}

.process-card__icon .v-icon {
  color: inherit;
  font-size: 23px;
}

.process-card__content {
  margin-top: 38px;
}

.process-card h3 {
  margin: 0 0 9px;
  font-size: 16px;
  line-height: 1.45;
}

.process-card p {
  margin: 0;
  color: var(--rl-muted);
  font-size: 13px;
  line-height: 1.7;
}

.process-card__arrow {
  position: absolute;
  z-index: 3;
  top: 50%;
  right: -27px;
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--rl-line);
  border-radius: 50%;
  color: var(--rl-red);
  background: #ffffff;
  box-shadow: 0 6px 18px rgba(26, 26, 26, 0.07);
  transform: translateY(-50%);
}

.process-card__arrow .v-icon {
  color: inherit;
  font-size: 18px;
}

.process-note {
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr);
  align-items: flex-start;
  gap: 14px;
  margin-top: 22px;
  padding: 18px 20px;
  border: 1px solid var(--rl-line);
  border-radius: 14px;
  background: var(--rl-surface);
}

.process-note__icon {
  width: 42px;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  color: #ffffff;
  background: var(--rl-red);
}

.process-note__icon .v-icon {
  color: inherit;
  font-size: 21px;
}

.process-note strong {
  display: block;
  margin-bottom: 4px;
  color: var(--rl-heading);
  font-family: Poppins-SemiBold, Poppins, sans-serif;
  font-size: 14px;
}

.process-note p {
  margin: 0;
  color: var(--rl-muted);
  font-size: 13px;
  line-height: 1.7;
}

/* ========================================
   FAQ
======================================== */

.faq-section {
  padding: 84px 0;
  background: var(--rl-surface);
}

.faq-layout {
  display: grid;
  grid-template-columns: minmax(260px, 0.75fr) minmax(0, 1.45fr);
  align-items: start;
  gap: 70px;
}

.faq-introduction {
  position: sticky;
  top: 24px;
}

.faq-introduction h2 {
  max-width: 420px;
}

.faq-introduction > p {
  max-width: 420px;
  margin: 16px 0 0;
  color: var(--rl-muted);
  font-size: 14px;
  line-height: 1.75;
}

.faq-introduction__link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 23px;
  color: var(--rl-red);
  font-family: Poppins-SemiBold, Poppins, sans-serif;
  font-size: 13px;
  text-decoration: none;
}

.faq-introduction__link:hover {
  color: var(--rl-red-hover);
  text-decoration: none;
}

.faq-introduction__link .v-icon {
  color: inherit;
  font-size: 18px;
  transition: transform 0.2s ease;
}

.faq-introduction__link:hover .v-icon {
  transform: translateX(3px);
}

.faq-list {
  display: grid;
  gap: 12px;
}

.faq-item {
  overflow: hidden;
  border: 1px solid var(--rl-line);
  border-radius: 14px;
  background: var(--rl-surface);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.faq-item[open] {
  border-color: var(--rl-red);
  box-shadow: var(--rl-shadow-sm);
}

.faq-item summary {
  min-height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 12px 16px;
  cursor: pointer;
  color: var(--rl-heading);
  font-family: Poppins-SemiBold, Poppins, sans-serif;
  font-size: 14px;
  line-height: 1.55;
  list-style: none;
}

.faq-item summary::-webkit-details-marker {
  display: none;
}

.faq-item summary:focus-visible {
  outline: 2px solid rgba(111, 16, 16, 0.32);
  outline-offset: -2px;
}

.faq-item__question {
  min-width: 0;
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
}

.faq-item__number {
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  color: #ffffff;
  background: var(--rl-red);
  font-size: 11px;
}

.faq-item__toggle {
  width: 34px;
  height: 34px;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: var(--rl-muted-dark);
  background: var(--rl-surface-soft);
}

.faq-item__toggle .v-icon {
  color: inherit;
  font-size: 20px;
  transition: transform 0.22s ease;
}

.faq-item[open] .faq-item__toggle {
  color: #ffffff;
  background: var(--rl-red);
}

.faq-item[open] .faq-item__toggle .v-icon {
  transform: rotate(180deg);
}

.faq-item__answer {
  padding: 0 62px 20px;
}

.faq-item__answer p {
  margin: 0;
  color: var(--rl-muted);
  font-size: 13px;
  line-height: 1.75;
}

/* ========================================
   BOTTOM CTA
======================================== */

.bottom-cta-section {
  padding: 0 0 84px;
  background: var(--rl-surface);
}

.bottom-cta {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
  overflow: hidden;
  padding: 40px 44px;
  border-radius: 22px;
  color: #ffffff;
  background: var(--rl-red);
  box-shadow: 0 22px 50px rgba(76, 10, 10, 0.18);
}

.bottom-cta::before,
.bottom-cta::after {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  content: '';
  pointer-events: none;
}

.bottom-cta::before {
  top: -110px;
  right: 130px;
  width: 240px;
  height: 240px;
}

.bottom-cta::after {
  right: -70px;
  bottom: -110px;
  width: 250px;
  height: 250px;
}

.bottom-cta__copy {
  position: relative;
  z-index: 2;
  max-width: 680px;
}

.bottom-cta__eyebrow {
  display: block;
  margin-bottom: 9px;
  color: white;
  font-family: Poppins-SemiBold, Poppins, sans-serif;
  font-size: 11px;
  line-height: 1.5;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.bottom-cta h2 {
  color: #ffffff;
  font-size: clamp(25px, 3vw, 34px);
}

.bottom-cta p {
  margin: 11px 0 0;
  color: rgba(255, 255, 255, 0.75);
  font-size: 14px;
  line-height: 1.7;
}

.bottom-cta__button {
  position: relative;
  z-index: 2;
  min-height: 49px;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  padding: 0 19px;
  border-radius: 10px;
  color: var(--rl-red);
  background: #ffffff;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.16);
  font-family: Poppins-SemiBold, Poppins, sans-serif;
  font-size: 13px;
  text-decoration: none;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.bottom-cta__button:hover {
  color: var(--rl-red-dark);
  text-decoration: none;
  box-shadow: 0 16px 34px rgba(0, 0, 0, 0.22);
  transform: translateY(-2px);
}

.bottom-cta__button .v-icon {
  color: inherit;
  font-size: 19px;
}

/* ========================================
   RESPONSIVE TABLET
======================================== */

@media (max-width: 991.98px) {
  .recommended-learn-hero {
    min-height: 480px;
    background-position: 60% center;
  }

  .recommended-learn-hero__overlay {
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.99) 0%,
      rgba(255, 255, 255, 0.96) 50%,
      rgba(255, 255, 255, 0.72) 72%,
      rgba(255, 255, 255, 0.2) 100%
    );
  }

  .recommended-learn-hero__copy {
    width: min(590px, 70%);
  }

  .recommended-learn-hero h1 {
    font-size: clamp(38px, 6vw, 50px);
  }

  .benefit-grid,
  .process-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .process-section__heading {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .process-section__heading > p {
    max-width: 650px;
  }

  .process-card__arrow {
    display: none;
  }

  .faq-layout {
    grid-template-columns: 1fr;
    gap: 35px;
  }

  .faq-introduction {
    position: static;
  }

  .faq-introduction h2,
  .faq-introduction > p {
    max-width: 660px;
  }

  .bottom-cta {
    align-items: flex-start;
    flex-direction: column;
  }
}

/* ========================================
   RESPONSIVE MOBILE
======================================== */

@media (max-width: 575.98px) {
  .recommended-learn-container,
  .recommended-learn-hero__container {
    width: min(100% - 24px, 1180px);
  }

  .recommended-learn-hero {
    min-height: 570px;
    align-items: flex-start;
    background-position: 65% center;
  }

  .recommended-learn-hero__overlay {
    background: rgba(255, 255, 255, 0.86);
  }

  .recommended-learn-hero__container {
    padding: 50px 0 42px;
  }

  .recommended-learn-hero__copy {
    width: 100%;
  }

  .hero-kicker {
    font-size: 12px;
  }

  .recommended-learn-hero h1 {
    max-width: 340px;
    margin-top: 18px;
    font-size: 36px;
    line-height: 1.13;
    letter-spacing: -1px;
  }

  .hero-description {
    max-width: 355px;
    font-size: 14px;
    line-height: 1.7;
  }

  .hero-actions {
    display: grid;
    grid-template-columns: 1fr;
    margin-top: 24px;
  }

  .hero-button {
    width: 100%;
  }

  .hero-highlights {
    display: grid;
    grid-template-columns: 1fr;
    gap: 8px;
    margin-top: 20px;
  }

  .learn-section,
  .process-section,
  .faq-section {
    padding: 62px 0;
  }

  .section-heading--center {
    text-align: left;
  }

  .section-heading--center > p {
    margin-right: 0;
    margin-left: 0;
  }

  .section-heading h2,
  .faq-introduction h2,
  .bottom-cta h2 {
    font-size: 27px;
    line-height: 1.3;
  }

  .benefit-grid,
  .process-list {
    grid-template-columns: 1fr;
  }

  .benefit-card {
    min-height: 0;
  }

  .process-card {
    min-height: 210px;
  }

  .process-card__content {
    margin-top: 28px;
  }

  .process-note {
    grid-template-columns: 38px minmax(0, 1fr);
    padding: 16px;
  }

  .process-note__icon {
    width: 38px;
    height: 38px;
  }

  .faq-layout {
    gap: 28px;
  }

  .faq-item summary {
    min-height: 68px;
    padding: 12px;
  }

  .faq-item__question {
    grid-template-columns: 30px minmax(0, 1fr);
    gap: 10px;
    font-size: 13px;
  }

  .faq-item__number {
    width: 30px;
    height: 30px;
  }

  .faq-item__toggle {
    width: 30px;
    height: 30px;
  }

  .faq-item__answer {
    padding: 0 52px 17px;
  }

  .bottom-cta-section {
    padding-bottom: 62px;
  }

  .bottom-cta {
    gap: 26px;
    padding: 30px 22px;
    border-radius: 18px;
  }

  .bottom-cta__button {
    width: 100%;
  }
}
</style>
